import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchTransfertsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchTransfertsDossierByIdController.php
* @route '/api/dossier-transferts/{dossier}'
*/
const FetchTransfertsDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchTransfertsDossierByIdController.url(args, options),
    method: 'get',
})

FetchTransfertsDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-transferts/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchTransfertsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchTransfertsDossierByIdController.php
* @route '/api/dossier-transferts/{dossier}'
*/
FetchTransfertsDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchTransfertsDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchTransfertsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchTransfertsDossierByIdController.php
* @route '/api/dossier-transferts/{dossier}'
*/
FetchTransfertsDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchTransfertsDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchTransfertsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchTransfertsDossierByIdController.php
* @route '/api/dossier-transferts/{dossier}'
*/
FetchTransfertsDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchTransfertsDossierByIdController.url(args, options),
    method: 'head',
})

export default FetchTransfertsDossierByIdController